module.exports = "<div id=\"aboutView\">\n\t<div>\n\t\t<div class=\"logo\"></div>\n\t\t<div class=\"productName\"></div>\n\t\t<div id=\"versionLabel\"></div>\n\t\t<div id=\"logLabel\" data-i18n=\"[prepend]common::log.title\"></div>\n\t\t<textarea id=\"logView\" data-role=\"none\" readonly=\"readonly\"></textarea>\n\t</div>\n</div>";


//////////////////
// WEBPACK FOOTER
// /jenkins/workspace/CudaLaunch_release_production/~/html-loader!./about/about_view.html
// module id = 61
// module chunks = 0 3